module.exports = __webpack_public_path__ + "static/media/next.ff2b9671.svg";